"use strict"

const { isVectorMethodsHostname, STORAGE_CONSENT_ROOT_DOMAIN } = require("./index")

const TOLT_PRIMARY_SCRIPT_URL = "https://files.tlt-cdn.com/tlt.js"
const TOLT_LEGACY_PRIMARY_SCRIPT_URL = "https://cdn.tolt.io/tolt.js"
const TOLT_SECONDARY_SCRIPT_URL = "https://cdn.jsdelivr.net/npm/psl/dist/psl.min.js"
const TOLT_COOKIE_NAMES = ["tolt_referral", "tolt_data"]
const RUNTIME_STARTED_ATTRIBUTE = "data-vm-tolt-runtime-started"
const RELOAD_REQUESTED_ATTRIBUTE = "data-vm-tolt-withdrawal-reload"

function markToltRuntimeStarted(documentRef) {
  const targetDocument = documentRef || (typeof document !== "undefined" ? document : null)
  if (targetDocument && targetDocument.documentElement) {
    targetDocument.documentElement.setAttribute(RUNTIME_STARTED_ATTRIBUTE, "true")
  }
}

function neutralizeToltScripts(documentRef, primaryScriptIds) {
  const knownIds = new Set(primaryScriptIds || [])
  for (const script of Array.from(documentRef.querySelectorAll("script"))) {
    const source = script.getAttribute("src")
    if (
      !knownIds.has(script.id)
      && source !== TOLT_PRIMARY_SCRIPT_URL
      && source !== TOLT_LEGACY_PRIMARY_SCRIPT_URL
      && source !== TOLT_SECONDARY_SCRIPT_URL
    ) {
      continue
    }

    script.onload = null
    script.onerror = null
    script.removeAttribute("src")
    script.remove()
  }
}

function deleteTrackingCookie(documentRef, windowRef, name, domain) {
  const attributes = [
    `${name}=`,
    "Path=/",
    "Max-Age=0",
    "Expires=Thu, 01 Jan 1970 00:00:00 GMT",
    "SameSite=Lax",
  ]
  if (windowRef.location.protocol === "https:") attributes.push("Secure")
  if (domain) attributes.push(`Domain=${domain}`)
  documentRef.cookie = attributes.join("; ")
}

function revokeToltRuntime(options) {
  const settings = options || {}
  const windowRef = settings.windowRef || (typeof window !== "undefined" ? window : null)
  const documentRef = settings.documentRef || (typeof document !== "undefined" ? document : null)
  if (!windowRef || !documentRef) return false

  const runtimeStarted = documentRef.documentElement
    && documentRef.documentElement.getAttribute(RUNTIME_STARTED_ATTRIBUTE) === "true"

  neutralizeToltScripts(documentRef, settings.primaryScriptIds)
  for (const cookieName of TOLT_COOKIE_NAMES) {
    deleteTrackingCookie(documentRef, windowRef, cookieName)
    if (isVectorMethodsHostname(windowRef.location.hostname)) {
      deleteTrackingCookie(documentRef, windowRef, cookieName, STORAGE_CONSENT_ROOT_DOMAIN)
    }
  }
  delete windowRef.tolt
  delete windowRef.tolt_data
  delete windowRef.tolt_referral

  if (
    settings.reloadIfStarted !== true
    || !runtimeStarted
    || !documentRef.documentElement
    || documentRef.documentElement.getAttribute(RELOAD_REQUESTED_ATTRIBUTE) === "true"
  ) {
    return false
  }

  documentRef.documentElement.setAttribute(RELOAD_REQUESTED_ATTRIBUTE, "true")
  const reloadPage = settings.reloadPage || (() => windowRef.location.reload())
  reloadPage()
  return true
}

module.exports = {
  TOLT_PRIMARY_SCRIPT_URL,
  TOLT_SECONDARY_SCRIPT_URL,
  markToltRuntimeStarted,
  revokeToltRuntime,
}
